import { RestAPI } from './rest-api.service';
import { BASE_URL } from '../types/constants';
import { TagDto } from '../types/admin.types';

const api = new RestAPI();

export type TagSort = 'popular' | 'recent';

export const searchTags = async (
    query?: string | null,
    limit: number = 20,
    sort: TagSort = 'popular'
): Promise<TagDto[]> => {
    const params = new URLSearchParams();
    if (query && query.trim().length > 0) {
        params.set('q', query.trim());
    }
    params.set('limit', String(limit));
    params.set('sort', sort);

    return api.get(`${BASE_URL}/v1/tags/search?${params.toString()}`);
};
